<script type="text/ecmascript-6">
    import TileQuestion from "./mixin/TileQuestion.vue";

    export default {
        mixins: [
            TileQuestion
        ],
        props: {
            title: {
                default(){
                    return 'Panel Moulding';
                }
            },
            component_id: {
                default(){
                    return 'moulding';
                }
            },
            maintitle: {
                default() {
                    return 'Select Panel Moulding';
                }
            },
            slab: {
                required: true,
            }
        },
        computed: {
            thumbURL(){
                return '/thumb/moulding/';
            },
            passed_filter(){
                return true;
                // return this.variable_ready(this.slab);
            },
            url(){
                return '/api/options/' + this.fabricator + '/moulding?slab=' + this.slab;
            },
            cache_key(){
                return '_' + this.slab;
            },
            panel_required(){
                return this.filtered_option_list.length > 0
            }
        },
        watch: {
            'cache_key': function (val, oldVal) {
                this.update_options();
            },
        }
    }
</script>
